import { useRef } from 'react'
import './style.css'

type UploadFilesProps = {
  setUploadedFiles: React.Dispatch<React.SetStateAction<File[]>>
  fileTypes: string
  labelText?: string
  buttontext: string
  isMultiple: boolean
  FileUploaderror?: string | null
  setFileUploadError?: any
  forceCameraOpen?: any
}

export const UploadFiles = ({
  setUploadedFiles,
  fileTypes,
  labelText,
  buttontext,
  isMultiple,
  FileUploaderror,
  setFileUploadError,
  forceCameraOpen,
}: UploadFilesProps) => {
  const inputRef = useRef<HTMLInputElement | null>(null)

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || [])
    const validTypes = fileTypes.split(',').map((type) => type.trim())
    const invalidFiles = files.filter((file) => {
      return !validTypes.some((validType) => {
        if (validType.endsWith('/*')) {
          return file.type.startsWith(validType.slice(0, -1))
        }
        return file.type === validType
      })
    })
    if (invalidFiles.length > 0) {
      setFileUploadError('Invalid file type(s) selected.')
      setTimeout(() => setFileUploadError(null), 2000)
    } else {
      setFileUploadError(null)
      setUploadedFiles((prev) => [...prev, ...files])
    }
    e.target.value = ''
  }

  return (
    <>
      <div className="upload-wrapper">
        <div className="upload-card">
          <div className="upload-icon">📄</div>
          <h4 className="upload-title">Customer bill is not uploaded</h4>
          <p className="upload-subtitle">Upload a clear bill image to continue</p>

          <button
            className="upload-button"
            onClick={(e) => {
              e.stopPropagation()
              inputRef.current?.click()
            }}
          >
            <i className="bi bi-arrow-up text-white m-2"></i>
            {buttontext}
          </button>
          <div className='mt-2 text-danger'>{labelText}</div>
          <p className="upload-formats">Supported formats: JPG, PNG, PDF (Max 10MB)</p>

          {FileUploaderror && (
            <p className="upload-error">{FileUploaderror}</p>
          )}
        </div>

        {/* Tips Section */}
        <div className="tips-card">
          <strong>💡 Tips for a good bill image</strong>
          <ul>
            <li>Use good lighting</li>
            <li>Capture all four corners</li>
            <li>
              Make sure the <b>customer name, account number and service address</b> are clearly readable
            </li>
          </ul>
        </div>

        <input
          ref={inputRef}
          type="file"
          multiple={isMultiple}
          accept={forceCameraOpen ? 'image/*' : fileTypes}
          capture={forceCameraOpen ? 'environment' : undefined}
          style={{ display: 'none' }}
          onChange={handleFileChange}
        />
      </div>
    </>
  )
}